/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import classNames from 'classnames';

import { connect } from 'react-redux';
import { compose } from 'redux';
import Header from '../../components/header/Header';
import LeftMenu from '../../components/left-menu/LeftMenu';
import { Loader } from '../../components/loader/Loader';
import SearchForm from '../../components/search-form/SearchForm';
import { STATUSES } from '../../core/api';
import { withAuth } from '../../core/auth/withAuth';
import { IReduxStoreState } from '../../core/store/interfaces';
import { findSelectedTopMenu, getSlug } from './helpers';
import { IMenu, IProps } from './interfaces';
import { fetchTopMenu, fetchSideMenu, fetchNestedSideMenu } from './redux';
import styles from './FrontLayout.module.styl';
import './FrontLayout.styl';
import { FrontendAdminToolbar } from '../../components/frontend-admin-toolbar';
import { fetchContent, fetchOldContent } from 'pages/content/redux';
import { getArticleSlug } from 'pages/content/helpers';
// import Donation from './donation.png';

export const FrontLayout: React.FC<IProps> = ({
  fetchTopMenu,
  fetchSideMenu,
  fetchNestedSideMenu,
  fetchContent,
  fetchOldContent,
  children,
  location: { search, hash },

  topMenu: {
    status: topMenuStatus,
    data: { items: topMenuItems },
  },
  sideMenu: {
    status: sideMenuStatus,
    data: { items: sideMenuItems },
  },
  match,
  user: {
    data: { data: userData },
  },
  match: {
    params: { locale },
  },
}) => {
  const currentYear = new Date().getFullYear();
  const slug = getSlug(match);
  const homeSlugs = ['default', 'home', 'category/home'];
  let articleSlug = getArticleSlug(match);
  const isHomePage = homeSlugs.includes(articleSlug);
  if (isHomePage) {
    articleSlug = 'default';
  }
  // add link to top sideMenu Items
  sideMenuItems.forEach(item => {
    item.link = `/${slug || 'home'}/${item.param}`;
  });
  const defaultMenu = topMenuItems.find(item => item.isDefault) as IMenu;
  const currentMenu = slug
    ? (topMenuItems.find(item => item.param === slug) as IMenu) || defaultMenu
    : defaultMenu;
  const selectedTopMenuItem = findSelectedTopMenu(topMenuItems, currentMenu);

  const renderAdminFrontendToolbar = () => {
    return ['editor', 'admin', 'superadmin'].includes(userData.type) ? (
      <FrontendAdminToolbar />
    ) : null;
  };

  // BE provides two different endpoints for content:
  // 1. /intranet/content/{id}/{searchString} // old Endpoint
  // 2. /internal-intranet/content/{id}/{searchString} // new Endpoint
  // Once BE migrate to new endpoint, we can remove old endpoint
  // New endpoint works for only homepage now!

  const fetchContents = () => {
    const fetchMethod = isHomePage ? fetchContent : fetchOldContent;
    fetchMethod(articleSlug, {
      hash,
      locale,
      search,
    });
  };

  React.useEffect(() => {
    topMenuStatus !== 'SUCCESS' && fetchTopMenu('');
  }, []);

  React.useEffect(() => {
    fetchContents();
  }, [articleSlug, locale, search]);

  React.useEffect(() => {
    currentMenu && fetchSideMenu(currentMenu.id);
  }, [currentMenu]);

  return (
    <div className={styles.root}>
      {renderAdminFrontendToolbar()}
      <div className={styles.header}>
        {topMenuItems.length > 0 && (
          <Header
            user={userData}
            menu={topMenuItems}
            activeMenu={selectedTopMenuItem}
          />
        )}
      </div>
      {sideMenuStatus === STATUSES.SUCCESS ? (
        <>
          <div className={styles.desktopSearch}>{<SearchForm />}</div>
          {/* //TODO: placeholder for next banner */}
          {/* <div className={styles.desktopSearch}>
            <a
              target="_blank"
              href="https://www.aktion-deutschland-hilft.de/de/aktiv-helfen/interaktiv-helfen/starte-deine-spendenaktion/meine-spendenaktion/?cfd=keo6l#cff"
            >
              <img alt="logo" src={Donation} style={{ width: '100%' }} />
            </a>
          </div> */}
          <div className={styles.main}>
            {sideMenuItems.length > 0 && (
              <div className={styles.leftMenu}>
                <LeftMenu
                  leftMenu={sideMenuItems}
                  fetchSideMenu={fetchSideMenu}
                  fetchNestedSideMenu={fetchNestedSideMenu}
                />
              </div>
            )}
            <div
              className={classNames(styles.content, {
                [styles.shrinked]: sideMenuItems.length > 0,
              })}
            >
              {children}
            </div>
          </div>
          <div className={styles.footer}>&copy; {currentYear} AUTO1 Group</div>
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
};

const mapState = (state: IReduxStoreState) => {
  const { topMenu, sideMenu } = state;

  return { topMenu, sideMenu };
};

const mapDispatch = {
  fetchTopMenu,
  fetchSideMenu,
  fetchNestedSideMenu,
  fetchContent,
  fetchOldContent,
};

export default compose(
  connect(mapState, mapDispatch),
  withAuth(),
)(FrontLayout) as React.ComponentClass;
